import { forwardRef, memo, ReactNode } from 'react';

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function createSvgIcon(
  path: ReactNode,
  viewBox: string = '0 0 24 24'
) {
  const Component = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
    <SvgIcon ref={ref} {...props} viewBox={viewBox}>
      {path}
    </SvgIcon>
  ));

  return memo(Component);
}
